import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import { notify } from "../common/Toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../common/forms.css";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      notify("Please fill in all fields.");
      return;
    }
    setLoading(true);
    const response = await ApiService.loginUser({ email, password });
    if (response) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("role", response.role);
      navigate("/", { replace: true });
    }
    setLoading(false);
  };

  return (
    <div className="form-page-container auth-form">
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email: </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password: </label>
          <div className="password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
        <button
          type="submit"
          className={loading ? "disabled" : undefined}
          disabled={loading}
        >
          {loading ? "Please wait..." : "Login"}
        </button>
      </form>
      <p className="register-link">
        Don't have an account? <Link to="/register">Register</Link>
      </p>
      <p className="register-link">
        Forgot your password? <Link to="/forgot-password">Reset it here</Link>
      </p>
    </div>
  );
}

export default LoginPage;
